<div class="main-content-container">
  <div class="main-container-body">
    @if (!utilService.isMobile() && _resourceDef) {
      <div class="page-title-container d-flex">
        <div class="page-title flex-grow-1">
          <div class="mb-0">
            {{_resourceDef.page_name.view | translate |async}}
          </div>
        </div>
        @if (rolePermision.checkAccessPermission('PATIENT_CARD', 'patient_update', 'patient-registration')) {
          <button class="secondary-btn float-right" type="button" (click)="printProfile(_currentData)"><i
          class="fa fa-print" aria-hidden="true"></i> {{'button.print_card' | translate |async}}
        </button>
      }
      @if (_resourceDef.qrCodeJson) {
        <i class="fa fa-qrcode pointer" style="font-size: 29px;" aria-hidden="true" [title]="title"
        (click)="generateQRCode(_currentData,_resourceDef.qrCodeJson)"></i>
      }
    </div>
  }
  @if (utilService.isMobile()) {
    <div class="_eps-mob-container float-right w-100 m-1 px-2" align="right">
      @if (rolePermision.checkAccessPermission('PATIENT_CARD', 'patient_update', 'patient-registration')) {
        <button class="secondary-btn float-right" type="button" (click)="printProfile(_currentData)"><i
        class="fa fa-print" aria-hidden="true"></i> {{'button.print_card' | translate |async}}
      </button>
    }
    @if (_resourceDef.qrCodeJson) {
      <i class="fa fa-qrcode pointer" style="font-size: 29px;" aria-hidden="true" [title]="title"
      (click)="generateQRCode(_currentData,_resourceDef.qrCodeJson)"></i>
    }
  </div>
}

<!-- <div class=""> -->
@if (_resourceDef) {
  <div class="row profile-wrapper">
    @for (res of _resourceDef.cards; track res) {
      @if (res.type == 'profile' && _currentData) {
        <div class="col-12 col-md-6 col-xl-4  profile-card-container"
          >
          <div class="profile-card-content shadow">
            <div class="profile-card-image">
              @if (!profile_path) {
                <img class="user-profile-image"
                  src="./assets/images/user-profile-image.png" loading="lazy" alt="Patient Profile">
                }
                @if (profile_path) {
                  <img class="user-profile-image" [src]="profile_path | secure  | async"
                    alt="Patient Profile">
                }
                @if (checkPermission() && uploadImage) {
                  <div class="profile-edit" (click)="editprofile()">
                    <span>
                      <i class="fa fa-pencil"></i>
                      {{'Edit Image' | translate | async }}
                    </span>
                  </div>
                }
                @if (checkProfilePermission()) {
                  <div class="profile-edit-demo card-edit-wrapper" (click)="updateProfile()"
                    >
                    <span style="color: black;">
                      <i class="fa fa-pencil"></i>
                      {{'Edit Profile' | translate | async }}
                    </span>
                  </div>
                }
              </div>
              <div class="profile-card-details">
                @for (c of res.fields; track c) {
                  <div class="profile-card-detail">
                    <div class="profile-label">
                      {{c.heading | translate | async}}
                    </div>
                    @if (c.type === 'composite') {
                      <div class="profile-other-detail">
                        {{((_currentData | mapvalue: c) != undefined || (_currentData | mapvalue: c) !=
                        'undefined') ? (_currentData | mapvalue: c) : not_filled}}
                      </div>
                    }
                    @if (c.type === 'date') {
                      <div class="profile-other-detail">
                        {{ (_currentData | mapvalue: c) ? (_currentData | mapvalue: c | dateFormat) :
                        not_filled}}
                      </div>
                    }
                    @if (c.type === 'datetime') {
                      <div class="profile-other-detail">
                        {{ (_currentData | mapvalue: c) ? (_currentData | mapvalue: c | dateTimeFormat)
                        : not_filled}}
                      </div>
                    }
                    @if (c.type === 'time') {
                      <div class="profile-other-detail">
                        {{ (_currentData | mapvalue: c) ? (_currentData | mapvalue: c | timeFormat) :
                        not_filled}}
                      </div>
                    }
                    @if (c.type === 'monthYear') {
                      <div class="profile-other-detail">
                        {{ (_currentData | mapvalue: c) ? (_currentData | mapvalue: c | timeFormat) :
                        not_filled}}
                      </div>
                    }
                    @if (c.type === 'array' || c.type === 'timeArray' || c.type === 'dateTimeArray') {
                      <div class="profile-other-detail"
                        >
                        {{(_currentData | mapvalue: c) ? (_currentData | mapvalue: c): not_filled}}
                      </div>
                    }
                    @if (c.type === 'composite-array') {
                      <div class="profile-detail">
                        {{getCompositeValue(_currentData,c)? getCompositeValue(_currentData,c) :
                        not_filled}}
                      </div>
                    }
                    @if (c.type === undefined) {
                      <div class="profile-other-detail">
                        {{ (_currentData[c.name])?(_currentData[c.name]):not_filled}}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <!---->
        @if (res.type != 'profile' && _currentData) {
          <div class="col-12 col-md-6 col-xl-4 details-card">
            <div class="details-card-content-wrapper shadow">
              <div class="details-card-top-section-wrapper">
                <div class="details-card-heading-wrapper">
                  <h4 class="profile-card-heading">{{res.heading | translate | async}}</h4>
                </div>
              </div>
              <!-- <h4 class="profile-card-heading">{{res.heading | translate | async}}</h4> -->
              <div class="details-card-content">
                @for (c of res.fields; track c) {
                  <div class="profile-card-other-detail">
                    <div class="profile-other-label">
                      {{c.heading | translate | async }}
                    </div>
                    @if (c.type === 'composite') {
                      <div class="profile-other-detail">
                        {{(_currentData | mapvalue: c) && (_currentData | mapvalue: c) != 'undefined' ?
                        (_currentData | mapvalue: c) : not_filled}}
                      </div>
                    }
                    @if (c.type === 'date') {
                      <div class="profile-other-detail">
                        {{ (_currentData | mapvalue: c) ? (_currentData | mapvalue: c | dateFormat) :
                        not_filled}}
                      </div>
                    }
                    @if (c.type === 'datetime') {
                      <div class="profile-other-detail">
                        {{ (_currentData | mapvalue: c) ? (_currentData | mapvalue: c | dateTimeFormat)
                        : not_filled}}
                      </div>
                    }
                    @if (c.type === 'time') {
                      <div class="profile-other-detail">
                        {{ (_currentData | mapvalue: c) ? (_currentData | mapvalue: c | timeFormat) :
                        not_filled}}
                      </div>
                    }
                    @if (c.type === 'monthYear') {
                      <div class="profile-other-detail">
                        {{ (_currentData | mapvalue: c) ? (_currentData | mapvalue: c | timeFormat) :
                        not_filled}}
                      </div>
                    }
                    @if (c.type === 'array' || c.type === 'timeArray' || c.type === 'dateTimeArray') {
                      <div class="profile-other-detail"
                        >
                        {{(_currentData | mapvalue: c) ? (_currentData | mapvalue: c): not_filled}}
                      </div>
                    }
                    @if (c.type === 'composite-array') {
                      <div class="profile-detail">
                        {{getCompositeValue(_currentData,c)? getCompositeValue(_currentData,c) :
                        not_filled}}
                      </div>
                    }
                    @if (c.type === undefined) {
                      <div class="profile-other-detail">
                        {{ (_currentData[c.name])?(_currentData[c.name]):not_filled}}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
      }
      <div class="col-12 col-md-6 col-xl-4 details-card">
        <div class="details-card-content-wrapper shadow">
          <div class="details-card-top-section-wrapper">
            <div class="details-card-heading-wrapper">
              <h4 class="profile-card-heading">{{(_resourceDef.tag_card_heading?_resourceDef.tag_card_heading:'field.label.patient_tag')|translate|async}} </h4>
            </div>
          </div>
          <!-- <h4 class="profile-card-heading">{{res.heading | translate | async}}</h4> -->
          @if (_currentData?.tag_data?.length) {
            <div class="details-card-content" >
              @for (c of _currentData.tag_data; track c) {
                <div class="profile-card-other-detail">
                  <div class="profile-other-label">
                    {{c.key_name }}
                  </div>
                  @if (!c.masking_required) {
                    <div class="profile-other-detail">
                      {{c.key_value_display }}
                    </div>
                  }
                  @if (c.masking_required) {
                    <div class="profile-other-detail">
                      {{c.key_value_display| mask}}
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (rolePermision.checkAccessPermission('patient_tag', 'patient_update', 'patient-registration')) {
            <button
              [ngClass]="_currentData?.tag_data?.length > 0 ? 'tag-button' : ''" type="button" class="btn btn-primary" (click)="addTag()">{{'field.label.add'|translate|async}} <i class="fa fa-plus"></i></button>
            }
          </div>
        </div>
        <!-- <div class="col-12 col-md-6 col-xl-4 details-card">
        <div class="details-card-content-wrapper shadow">
          <h3>Kin Details</h3>
          <div class="details-card-content">
            <div class="profile-card-other-detail">
              <div class="profile-other-label">
                Father's name
              </div>
              <div class="profile-other-detail">
                Chuck Henkins
              </div>
            </div>
            <div class="profile-card-other-detail">
              <div class="profile-other-label">
                Mother's name
              </div>
              <div class="profile-other-detail">
                Jeena Silvers
              </div>
            </div>
            <div class="profile-card-other-detail">
              <div class="profile-other-label">
                State
              </div>
              <div class="profile-other-detail">
                Haryana
              </div>
            </div>
            <div class="profile-card-other-detail">
              <div class="profile-other-label">
                City
              </div>
              <div class="profile-other-detail">
                Gurgaon
              </div>
            </div>
            <div class="profile-card-other-detail">
              <div class="profile-other-label">
                Identity Filled
              </div>
              <div class="profile-other-detail">
                Yes
              </div>
            </div>
            <div class="profile-card-other-detail">
              <div class="profile-other-label">
                Created By
              </div>
              <div class="profile-other-detail">
                BL Admin
              </div>
            </div>
            <div class="profile-card-other-detail">
              <div class="profile-other-label">
                Modified Date/Time
              </div>
              <div class="profile-other-detail">
                22/09/2021 15:56 pm
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  }
<!-- </div> -->
</div>
</div>